import type { HomepagePayload } from "@/lib/homepage";

export type HomepageProps = {
  data: HomepagePayload;
};

export function firstAsset(data: HomepagePayload, category: string) {
  return data.assets[category]?.[0];
}

export function assetsFor(data: HomepagePayload, category: string) {
  return data.assets[category] || [];
}

export function sectionFor(data: HomepagePayload, key: string) {
  return data.sections[key] || { sectionKey: key, metadata: {} };
}
